// extracted by mini-css-extract-plugin
export default {"userProfile":"userProfile_userProfile__RCiYm","userProfile__head":"userProfile_userProfile__head__L31CS"};